import XLSX from "xlsx-js-style";

/**
 * 엑셀 다운로드
 * @param {Array} header ReactDataTable에 넘기는 header정보 (col, header, notView 사용)
 * @param {Array} data ReactDataTable에 넘기는 data정보
 * @param {String} fileName default는 "download.xlsx"
 * @param {String} sheetName default는 "sheet"
 */
export const excelDownload = (header, data, fileName = "download.xlsx", sheetName = "sheet") => {

	const getHeaderCell = (val) => {
		let cell = getDefaultCell(val);
		// header Cell s 항목에서 다른 부분
		const headerCellS = {
			font: { sz: "13" },
			fill: { fgColor: {rgb: "e6e6e6" }},
		}
		cell.s = { ...cell.s, ...headerCellS}
		return cell;
	}
	const getDefaultCell = (val) => {
		return ({
			v: val ?? "",
			t: "s",
			s: {
				border: {
					top: { style: "thin", color: { rgb: "000000" } },
					bottom: { style: "thin", color: { rgb: "000000" } },
					left: { style: "thin", color: { rgb: "000000" } },
					right: { style: "thin", color: { rgb: "000000" } },
				},
			}
		});
	}
	const excelHeader = header.filter((h) => !h.notView).map((h) => {
		return getHeaderCell(h.header);
	});

	const visibleHeader = header.filter((h) => !h.notView).map((h) => {
		return {col: h.col, type: h.type};
	});
	const excelBody = data.map((d) => {
		return visibleHeader.map((h) => {
			const cell =  getDefaultCell(d[h.col]);
			if(h.type === "number" || h.type === "float" || typeof d[h.col] === "number") {
				// 숫자일때 형식 지정
				cell.t = "n";
				cell.s.numFmt = "#,##0";
				if(String(d).includes(".")) {
					// 소수점 있으면 소수점 1자리
					cell.s.numFmt = "#,##0.0"
				}
			} 
			return cell;
		});
	});

	const wb = XLSX.utils.book_new();
	const ws = XLSX.utils.aoa_to_sheet([excelHeader, ...excelBody]);
	
	ws['!cols'] = header.filter((h) => !h.notView).map((h) => ({ wpx: h.cellWidth }));

	XLSX.utils.book_append_sheet(wb, ws, sheetName)

	XLSX.writeFile(wb, fileName);
}